function submitMemberEditForm(formFields, formId) {
  saveBtn.innerHTML = "Saving...";
  saveBtn.disabled = true;

  return formHelpers
    .createFormData(formFields, formId)
    .then(function (formData) {
      return window.fetch(window.location, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          data: formData,
          contacts: window.formTypeHelpers
            .getContacts()
            .map(function (contact) {
              if (contact && contact.data) {
                return contact.data;
              }
            })
            .filter(Boolean),
          locations: window.formTypeHelpers
            .getLocations()
            .map(function (location) {
              if (location && location.data) {
                return location.data;
              }
            })
            .filter(Boolean),
        }),
      });
    })
    .then(function (response) {
      if (response.ok) {
        saveBtn.innerHTML = "Saved!";
        saveBtn.disabled = false;
      } else {
        alert.innerHTML =
          "There was an issue saving these updates. Please contact us directly for more assistance.";
        saveBtn.innerHTML = "Save";
        saveBtn.disabled = false;
      }
    });
}

function submitMemberAppForm(formFields, formId, formAlert) {
  return formHelpers
    .createFormData(formFields, formId)
    .then(function (formData) {
      return window.fetch("/membership-application", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          data: formData,
          contacts: window.formTypeHelpers
            .getContacts()
            .map(function (contact) {
              if (contact && contact.data) {
                return contact.data;
              }
            })
            .filter(Boolean),
          locations: window.formTypeHelpers
            .getLocations()
            .map(function (location) {
              if (location && location.data) {
                return location.data;
              }
            })
            .filter(Boolean),
        }),
      });
    })
    .then(function (response) {
      if (response.ok) {
        localStorage.removeItem(formId);
        localStorage.removeItem(formId + "-contacts");
        localStorage.removeItem(formId + "-locations");
        window.location = "/membership-application/complete";
      } else {
        formAlert.innerHTML =
          "There was an issue processing this membership application. Please contact us directly for more assistance.";
        document.querySelector("form.form").scrollIntoView();
        nextBtn.innerHTML = "Submit";
        nextBtn.disabled = false;
      }
    }); 
}

function submitMemberRenewalForm(formFields, formId, formAlert) {
  if (
    document.getElementById("renewalStatus") &&
    document.getElementById("renewalStatus").value == "false"
  ) {
      return formHelpers
        .createFormData(formFields, formId)
        .then(function (formData) {
          return window.fetch("/membership-renewal", {
            method: "POST",
            credentials: "include",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify({
              data: formData,
              contacts: window.memberAppHelpers.getContacts().filter(Boolean),
              locations: window.memberAppHelpers.getLocations().filter(Boolean),
            }),
          });
        })
        .then(function (response) {
          if (response.ok) {
            window.location = "/membership-renewal/cancelled";
          } else {
            formAlert.innerHTML =
              "There was an issue cancelling your company's membership. Please contact us directly for more assistance.";
            nextBtn.innerHTML = "Submit";
            nextBtn.disabled = false;
          }
        });
  } else {
    return formHelpers
      .createFormData(formFields, formId)
      .then(function (formData) {
        return window.fetch("/membership-renewal", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            data: formData,
            contacts: window.memberAppHelpers.getContacts().filter(Boolean),
            locations: window.memberAppHelpers.getLocations().filter(Boolean),
          }),
        });
      })
      .then(function (response) {
        if (response.ok) {
          console.log(response);
          window.location = "/membership-renewal/complete";
        } else {
          formAlert.innerHTML =
            "There was an issue processing this membership renewal. Please contact us directly for more assistance.";
          nextBtn.innerHTML = "Submit";
          nextBtn.disabled = false;
        }
      });
  }
}

window.memberFormHelpers = {
  submitMemberAppForm: submitMemberAppForm,
  submitMemberEditForm: submitMemberEditForm,
  submitMemberRenewalForm: submitMemberRenewalForm,
};
